import { FC, useState } from 'react';
import { useFormik } from 'formik';
import SubmittedLoginForm from '../../components/Login/SubmittedLoginForm';
import LoginForm from '../../components/Login/LoginForm';
import { sendMagicLinkToEmail } from '../../api/auth';
import { checkEmail } from '../../api/members';
import './Login.scss';
import { emailRegexp } from '../../utils/constants';

const Login: FC = () => {
  const [isFormSubmitted, setIsFormSubmitted] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const validate = (values: { email: string }) => {
    const errors: { email?: string } = {};
    if (!values.email) {
      errors.email = 'Email is required';
    } else if (!emailRegexp.test(values.email)) {
      errors.email = 'Invalid email address';
    }

    return errors;
  };

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validate,
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        // First check if email exists
        const emailCheckResponse = await checkEmail(values.email);
        if (emailCheckResponse.status !== 'success') {
          const errorMessage = 'Not allowed to login with this email.';
          formik.setFieldError('email', errorMessage);
          return;
        }

        // If email check passes, send magic link
        const response = await sendMagicLinkToEmail(values.email);
        if (response.status && response.status === 400) {
          formik.setFieldError('email', 'No account found for this email.');
          return;
        }
        if (response.status && response.status !== 200) {
          formik.setFieldError('email', 'Error occurred, please try again.');
          return;
        }

        setIsFormSubmitted(true);
      } catch (error) {
        console.error('Error during login process:', error);
        formik.setFieldError('email', 'Error occurred, please try again.');
      } finally {
        setIsLoading(false);
      }
    },
    validateOnBlur: false,
    validateOnChange: false,
  });

  return (
    <>
      {!isFormSubmitted ? (
        <LoginForm
          setIsFormSubmitted={setIsFormSubmitted}
          isLoading={isLoading}
          formik={formik}
        />
      ) : (
        <SubmittedLoginForm
          email={formik.values.email}
          onBack={() => setIsFormSubmitted(false)}
        />
      )}
    </>
  );
};

export default Login;
